export const parseNullableDate = (value?: string | null): Date => {
  if (value === undefined) return new Date();

  if (value === null) return new Date(NaN);

  return new Date(value);
};
